import { Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../shared/store/common/component-store-v2.factory';

@Injectable()
export class RestoreFolderModalStore extends ComponentStoreV2Factory {
}
